import { render, staticRenderFns } from "./ProductTitle.vue?vue&type=template&id=64cb6c0e&scoped=true&"
import script from "./ProductTitle.vue?vue&type=script&lang=ts&"
export * from "./ProductTitle.vue?vue&type=script&lang=ts&"
import style0 from "./ProductTitle.vue?vue&type=style&index=0&id=64cb6c0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cb6c0e",
  null
  
)

export default component.exports